import { FGridItem } from "ferrum-design-system";
import React, { useEffect, useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/rootReducer";
import { addClassToBodyTag } from "../../../../utils/helperFunctions";
import { useHistory } from "react-router-dom";

export const SwapPageTokenNetworkSelector = ({
  selectorFor,
  isApproving,
  selectorInfo,
  setTokenSelectorDialogFor,
  setShowTokenSelectorDialog,
  networkParamsShift,
  setNetworkParamsShift,
}: any) => {
  const history = useHistory();
  const [networkNameToShow, setNetworkNameToShow] = useState(
    selectorInfo?.network?.name || "Network"
  );
  const { selectedNetwork } = useSelector((state: RootState) => state.networks);

  useEffect(() => {
    if (selectorInfo?.network?.name) {
      setNetworkNameToShow(selectorInfo?.network?.name);
    } else if (selectorFor === "From" && !selectorInfo?.network?.name) {
      setNetworkNameToShow(selectedNetwork?.name);
      // } else {
      //   setNetworkNameToShow("Network");
    }
  }, [selectorInfo]);

  const handleSelectorFor = (selectorName: string) => {
    if (selectorFor === "From") {
      setTokenSelectorDialogFor(`FROM_${selectorName}`);
    } else if (selectorFor === "To") {
      setTokenSelectorDialogFor(`TO_${selectorName}`);
    }
  };
  const updateUrlParameters = (chainId: string, currency: string) => {
    const queryParams = new URLSearchParams(window.location.search);

    if (selectorFor === "From") {
      queryParams.set("inputCurrency", `${currency}`);
      queryParams.set("inputChainId", chainId);
    }
    if (selectorFor === "To") {
      queryParams.set("outputCurrency", `${currency}`);
      queryParams.set("outputChainId", chainId);
    }
    history.push({
      pathname: "/swap",
      search: queryParams.toString(),
    });
  };

  useEffect(() => {
    if (
      networkParamsShift &&
      (selectorInfo?.network?.chainId || selectorInfo?.token?.address)
    ) {
      updateUrlParameters(
        selectorInfo?.network?.chainId,
        selectorInfo?.token?.address
      );
    }
  }, [networkParamsShift]);

  return (
    <FGridItem
      size={[3, 3, 3]}
      className={`ms-card-select-${selectorFor?.toLowerCase()}`}
    >
      <label className={`ms-card-select-${selectorFor?.toLowerCase()}-title`}>
        {selectorFor}
      </label>
      <div
        className={`ms-card-select-${selectorFor?.toLowerCase()}-network cursor-pointer`}
        onClick={() => {
          setShowTokenSelectorDialog(true);
          setNetworkParamsShift(false);
          handleSelectorFor("NETWORK");
          addClassToBodyTag(true);
        }}
      >
        {selectorInfo?.network?.image ? (
          <img
            src={selectorInfo?.network?.image}
            alt={"Network Logo"}
            width="25px"
            height="25px"
            className="f-mr--5"
          />
        ) : selectorFor === "From" && selectedNetwork?.image ? (
          <img
            src={selectedNetwork?.image}
            alt={"Network Logo"}
            width="24px"
            height="24px"
            className="f-mr--5"
          />
        ) : null}
        <span className={` ${selectorInfo?.network?.name ? "f-mr--5" : ""} `}>
          {networkNameToShow ? networkNameToShow : "Network"}
        </span>
        <div className="network-arrow-down">
          <MdKeyboardArrowDown className="" />
        </div>
      </div>
      <div
        className={`ms-card-select-${selectorFor?.toLowerCase()}-token ms-card-select-${selectorFor?.toLowerCase()}-network cursor-pointer`}
        onClick={() => {
          setShowTokenSelectorDialog(true);
          setNetworkParamsShift(false);
          handleSelectorFor("TOKEN");
          addClassToBodyTag(true);
        }}
      >
        {selectorInfo?.token?.logoURI && (
          <img
            src={selectorInfo?.token?.logoURI}
            alt={"Network Logo"}
            width="24px"
            height="24px"
            className="f-mr--5"
          />
        )}
        <span className={` ${selectorInfo?.token?.symbol ? "f-mr--5" : ""} `}>
          {selectorInfo?.token?.symbol
            ? selectorInfo?.token?.symbol
            : "Select Token"}
        </span>
        <div className="network-arrow-down">
          <MdKeyboardArrowDown className="" />
        </div>
      </div>
    </FGridItem>
  );
};
